import nvidiaLogo from '../../assets/Newsletter/Nvidia.png';
import intechsanteLogo from '../../assets/Newsletter/Intechsante.png';
import siliconIndiaCertificate from '../../assets/Newsletter/Silicon India.png';

export const newsroomItems = [
  {
    slug: 'siliconindia',
    title: 'Honoured and Elated: Celebrating Our SiliconIndia Recognition',
    excerpt:
      'Vardaan Data Sciences has been recognised as Startup of the Year in GRC & Third Party Risk Management by SiliconIndia Magazine — a proud milestone for our team and a testament to our disciplined execution, customer trust, and commitment to solving complex business challenges.',
    date: '2026',
    category: 'Press Release',
    tagLabel: 'Recognition',
    tagVariant: 'clay',
    filterKeys: ['announcements', 'press'],
    coverType: 'siliconindia',
    image: siliconIndiaCertificate,
    imageAlt: 'SiliconIndia Startup of the Year certificate',
  },
  {
    slug: 'nvidia-inception',
    title: 'Vardaan joins the NVIDIA Inception Program.',
    excerpt:
      'Vardaan Data Sciences is now a member of the NVIDIA Inception program. Our membership reflects our continued focus on AI innovation and the ongoing development of RiskaVaire — our AI-native Governance, Risk and Compliance platform, which leverages NVIDIA NIM, NVIDIA NeMo Retriever, and NVIDIA NeMo Guardrails.',
    date: 'June 2026',
    category: 'Press Release',
    tagLabel: 'Program Membership',
    tagVariant: 'green',
    filterKeys: ['announcements', 'press'],
    coverType: 'nvidia',
    image: nvidiaLogo,
    imageAlt: 'NVIDIA Inception Program Member',
  },
  {
    slug: 'intechsante',
    title: 'When health systems finally learn to talk to each other.',
    excerpt:
      "Vardaan CEO Gopakumar N. Kavunkal joins Forum INTECHSANTÉ at the Côte d'Ivoire Medical Expo 2026 for a panel on interoperability and the technical standards behind an integrated African digital health ecosystem.",
    date: '19 June 2026',
    category: 'Speaking Engagement',
    tagLabel: 'Speaking Engagement',
    tagVariant: 'teal',
    filterKeys: ['speaking'],
    coverType: 'intechsante',
    image: intechsanteLogo,
    imageAlt: 'Forum INTECHSANTÉ Medical Expo',
    eventVisual: {
      location: "Abidjan · Côte d'Ivoire",
      day: '19',
      month: 'Jun',
      year: '2026',
      name: "Forum INTECHSANTÉ · Médical Expo Côte d'Ivoire",
    },
  },
];

export const FILTER_OPTIONS = [
  { id: 'all', label: 'All Stories' },
  { id: 'announcements', label: 'Announcements' },
  { id: 'speaking', label: 'Speaking' },
  { id: 'press', label: 'Press' },
];
